import {QUERY_KEYS} from '@/queryClient'
import {useQuery} from '@tanstack/react-query'
import {httpGetMembers} from '../services/workspaces.http'

export const useGetMembers = ({workspaceId}: {workspaceId: string}) =>
    useQuery({
        queryKey: [QUERY_KEYS.MEMBERS, workspaceId],
        queryFn: () => httpGetMembers({workspaceId})
    })
